import { JOB_LANDING, JOB_LP, JOB_LANDING_WITH_SEO, JOBS_GENERIC_LP } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'

import { defaultInfo, defaultInternalLinks, defaultBreadcrumbs, defaultSeoContent } from './defaultState'

const unwrapState = state => state.landingPage || {}

export const isLandingPageVisible = state => [JOB_LANDING, JOB_LP, JOB_LANDING_WITH_SEO, JOBS_GENERIC_LP].includes(getPageType(state))
export const getLandingPageInfo = state => unwrapState(state).info || defaultInfo
export const landingPageHasSeoText = state => {
  const info = unwrapState(state).info || defaultInfo
  return !!info.content
}
export const getInternalLinks = state => unwrapState(state).internalLinks || defaultInternalLinks
export const getBreadcrumbs = state => unwrapState(state).breadcrumbs || defaultBreadcrumbs
export const getSeoContent = state => unwrapState(state).seoContent || defaultSeoContent
